// @flow
import * as React from 'react';
import { Position, Text, Button, Columns, Column } from '@locus-taxy/neo-ui';
import TimeUtils from 'common/utils/TimeUtils';
import { useTranslation } from 'react-i18next';
import { useMinimalClient } from 'common/modules/minimal-client-settings';

export const ExpiryBanner = (): React.Node => {
    const { expiresOn } = useMinimalClient();
    const { t } = useTranslation('platform');
    const initialShowBanner = expiresOn
        ? TimeUtils.isAfter(
              TimeUtils.now(),
              TimeUtils.subtract({ date: expiresOn, period: 7 })
          )
        : false;
    const pendingDays = TimeUtils.diff({
        startDate: TimeUtils.now(),
        endDate: expiresOn,
        unit: 'days'
    });
    const [showBanner, setShowBanner] = React.useState(initialShowBanner);

    return showBanner ? (
        <Position
            position="absolute"
            display="flex"
            width="100%"
            height={54}
            alignItems="center"
            backgroundColor="yellow.500"
            justifyContent="center"
            zIndex="highest"
            p={2}
        >
            <Columns alignY="center" _sx={{ width: '100%' }}>
                <Column width="fluid">
                    <Text size="large" textAlign="center">
                        {pendingDays > 0
                            ? t('clientExpiryMessage', { n: pendingDays })
                            : t('clientExpiredMessage')}
                    </Text>
                </Column>
                <Column width="content">
                    <Button
                        icon="cross"
                        appearance="icon"
                        onClick={() => setShowBanner(false)}
                    />
                </Column>
            </Columns>
        </Position>
    ) : null;
};

export default ExpiryBanner;
